import { render, staticRenderFns } from "./AccountsTable.vue?vue&type=template&id=5916ac10"
import script from "./AccountsTable.vue?vue&type=script&lang=js"
export * from "./AccountsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports